import { useMemo } from 'react';
import { compact } from 'lodash';

import { EMAILS_CHANNELS_AND_RESOURCES, flatConnectedAccounts } from 'src/data/performance';

import { useChannelAccounts } from './useChannelAccounts';

export const useEmailConnectedAccounts = () => {
  const { connectedAccounts } = useChannelAccounts();

  return useMemo(() => {
    const accountsPerChannel = compact(
      EMAILS_CHANNELS_AND_RESOURCES.map((channel) => connectedAccounts[channel])
    );
    return flatConnectedAccounts(accountsPerChannel, true);
  }, [connectedAccounts]);
};
